import documentTypes from './document-type/index';

export default function favoritType(app) {
	app.constant("DOCUMENT_TYPE", documentTypes);
}
